import { FilterColumn } from './filter-column.model';
import { Group } from './group.model';

export interface FilterControls<T> {
  id: string;
  columns: FilterColumn[];
  disableRowGroupFiltering?: boolean;
  placeholder?: string;
  customFilterPredicate?: (data: T | Group, filter: string) => boolean;
}
